module.exports = __webpack_public_path__ + "static/img/guidethepublic.adff5f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guidethepublic.png
// module id = RPCg
// module chunks = 5